import { Cookies } from 'react-cookie';

import axiosInterceptor from '../interceptor/axiosClient';

import { LoginResponse, UserLoginData } from './types';

const ACCESS_TOKEN_COOKIE = 'local_access_token';
const COOKIE_OPTIONS = { path: '/' };

export const login = async (loginData: UserLoginData) => {
  const res = await axiosInterceptor.post<LoginResponse>('/login/FRA/', loginData);

  const cookies = new Cookies();
  cookies.set(ACCESS_TOKEN_COOKIE, `Token ${res.data.token}`, COOKIE_OPTIONS);

  return res.data as LoginResponse;
};
